export interface IUiConfigButton {
  label: string;
  onClick: () => void;
  className: string;
  type: "button" | "submit" | "reset";
  color: "primary" | "default";
  outline: boolean;
  isDisabled: boolean;
}

export interface IUiConfigButtonVisible {
  value: string;
  isVisible: boolean;
  enable?: {
    isEnable?: boolean;
  };
}

export interface IUiConfigButtonActionBody {
  loanApplicationID?: string;
  resourceName?: string;
  sectionName?: string;
  userID?: string;
  [key: string]: string | undefined;
}

export interface IUiConfigButtonAPIActionParams {
  body: IUiConfigButtonActionBody;
  endpoint: string;
  method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH";
}

export enum IUiConfigButtonFunctionName {
  MFLBL_DEDUPE_FUNCTION = "mflbl_dedupe_function"
}
export interface IUiConfigButtonFunctionActionParams {
  functionName: IUiConfigButtonFunctionName;
  args: any;
  body: IUiConfigButtonActionBody;
  endpoint: string;
  method: "GET" | "POST" | "PUT" | "DELETE" | "PATCH";
}

export type IUiConfigButtonAction =
  | {
      type: IUiConfigButtonActionType.API_CALL;
      params: IUiConfigButtonAPIActionParams;
    }
  | {
      type: IUiConfigButtonActionType.FUNCTION_CALL;
      params: IUiConfigButtonFunctionActionParams;
    };

export interface IBaseUiConfigButtonConfig {
  status?: number;
  visible: IUiConfigButtonVisible;
  label: string;
  icon: string;
  action: IUiConfigButtonAction;
  component?: {
    componentType?: string;
    rendererType?: string;
    componentName?: string;
    componentSize?: string;
  };
  position?: number;
  key?: string;
}

export interface IUiConfigButtonConfig extends IBaseUiConfigButtonConfig {
  key: string;
}

export interface IUiConfigButtonClientSideInput {
  loanApplicationID: string;
  userID: string;
  token: string;
  [key: string]: string;
}

export interface IUiConfigButtonProps {
  clientSideInput: IUiConfigButtonClientSideInput;
  buttonConfig: IUiConfigButtonConfig;
  onClickFinished?: (
    response: any,
    buttonConfig: IBaseUiConfigButtonConfig
  ) => void;
  styles?: {
    className?: string;
    size?: "small" | "default" | "large";
  };
  sectionID?: string;
  tabName?: string;
  loanApplicationID: string;
  isLenderDashboard: boolean;
  onPostClick?: () => void;
  onSuccess?: (response: IActionResponse) => void;
  notifySuccess?: boolean;
}

export interface IActionResponse {
  data: {
    message?: string;
    [key: string]: unknown;
  };
  error: string;
  status: boolean;
}

// Enums

export enum IUiConfigButtonActionType {
  API_CALL = "api_call",
  FUNCTION_CALL = "function_call"
}

export enum IUiConfigButtonComponentSize {
  s = "s",
  m = "m",
  l = "l"
}
